app.service('basketWarranty', function (orderConfig, console, warrantyEncouragement, broker, loading, basketAnalytics) {
	function change(value, productId) {
		$(`#warranty-${productId}`)
			.val(value)
			.change();
	}
	function action(ajaxData, callback) {
		if (ajaxData.warrantyId || ajaxData.mainCartItemId) {
			loading.start();
			$.ajax({
				url: '/cart-item-operation.ltr',
				method: 'post',
				data: ajaxData,
				cache: false,
				success: function (json) {
					console.log('GWARANCJA - ' + ajaxData.action + ' - OK');
					if (typeof callback === "function") {
						callback();
					} else {
						loading.stop();
					}
				},
				error: function () {
					modal.alert('Wystąpił błąd operacji na gwarancjach. Prosimy spróbować ponownie');
				}
			});
		}
	}
	function open(params) {
		warrantyEncouragement.load({
			productId: params.productId,
			mainCartItemId: params.mainCartItemId,
			packageIdentifier: params.packageIdentifier,
			relatedPromotionIdentifier: params.relatedPromotionIdentifier,
			variant: params.variant,
			defaultSelectedWarranty: params.defaultSelectedWarranty,
			showGradeInfoFromCart: params.showGradeInfoFromCart,
			categoryGradeInfoFromCart: params.categoryGradeInfoFromCart,
			callback: function (actionType, data) {
				if (actionType == 'UPDATE' || actionType == 'ADD') {
					add({
						mainCartItemId: params.mainCartItemId,
						quantity: data.quantity,
						warrantyId: data.warrantyId,
						warrantyName: data.warrantyName,
						warrantyCategory: data.warrantyCategory,
						warrantyPrice: data.warrantyPrice,
						packageIdentifier: params.packageIdentifier ? params.packageIdentifier : undefined,
						relatedPromotionIdentifier: params.relatedPromotionIdentifier ? params.relatedPromotionIdentifier : undefined,
						warrantyPaymentType: data.warrantyPaymentType,
						productPlu: params.productPlu,
						isProductInstallmentPrice: params.isProductInstallmentPrice,
						place: 'warranty_details'
					});
				} else {
					action({
						mainCartItemId: params.mainCartItemId,
						warrantyId: data.warrantyId,
						action: 'REMOVE_MAIN_CART_ITEM_WARRANTY',
						addedFrom: 'TO_CART',
						warrantyPaymentType: ''
					}, function () {
						basketAnalytics.removeWarranty(params.productPlu, data.warrantyId, data.warrantyPaymentType);
						broker.trigger('REFRESH_BASKET_VIEW', { main: params.mainCartItemId, type: 'remove-warranty'});
					});
				}
			}
		});
	}
	function add(params) {
		var config = orderConfig.getData();
		action({
			mainCartItemId: params.mainCartItemId,
			quantity: params?.quantity || $('#warranty-' + params.mainCartItemId).val() || 1,
			warrantyId: params.warrantyId,
			packageIdentifier: params.packageIdentifier ? params.packageIdentifier : undefined,
			relatedPromotionIdentifier: params.relatedPromotionIdentifier ? params.relatedPromotionIdentifier : undefined,
			action: params.packageIdentifier ? 'OVERWRITE_PACKAGE_WARRANTY' : 'OVERWRITE_MAIN_CART_ITEM_WARRANTY',
			addedFrom: params.addedFrom ? params.addedFrom : 'TO_CART',
			warrantyAddedFrom: config.basketType == 'MIXED' ? 'CART_EDIT_MIXED' : (config.basketType == 'INSTALLMENT' ? 'CART_EDIT_INSTALLMENT' : 'CART_EDIT_COMMON'),
			warrantyPaymentType: params.warrantyPaymentType
		}, function () {
			basketAnalytics.addWarranty(params);
			broker.trigger('REFRESH_BASKET_VIEW', { main: params.mainCartItemId, type: 'add-warranty', id: params.warrantyId });
		});
	}
	return {
		change,
		open,
		add
	};
});
